import React, { useState } from 'react';
import { Search, Bell, User, Settings, LogOut, Menu, X } from 'lucide-react';
import { useSession } from '../../contexts/SessionContext';
import { useNotifications } from '../../contexts/NotificationContext';
import './AdminNavbar.css';

const AdminNavbar = ({ activeTab, setActiveTab, userEmail, onToggleSidebar, sidebarCollapsed, children }) => {
  const { logout } = useSession();
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();
  const [searchQuery, setSearchQuery] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    // Handle search functionality
    console.log('Searching for:', searchQuery);
  };

  const handleNotificationClick = (notification) => {
    if (notification.unread) {
      markAsRead(notification.id);
    }
  };

  const handleMarkAllRead = () => {
    markAllAsRead();
    setShowNotifications(false);
  };

  return (
    <>
      <div className="admin-navbar">
        <div className="admin-navbar-content">
          <div className="admin-navbar-left">
          <button 
            className="admin-menu-toggle"
            onClick={onToggleSidebar}
          >
            {sidebarCollapsed ? <Menu size={20} /> : <X size={20} />}
          </button>
          <div className="admin-brand" aria-label="Brand">
            <div className="admin-brand-logo">
              <img
                className="admin-brand-img"
                src={`${process.env.PUBLIC_URL || ''}/sonickart1.jpg`}
                alt="SoniCKart"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
            <span className="admin-brand-text">SonicKart</span>
          </div>

          <div className="admin-navbar-nav">
            <div className="admin-nav-tabs">
              <button 
                className={`admin-nav-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
                onClick={() => setActiveTab('dashboard')}
              >
                Dashboard
              </button>
              <button 
                className={`admin-nav-tab ${activeTab === 'vendors' ? 'active' : ''}`}
                onClick={() => setActiveTab('vendors')}
              >
                Vendors
              </button>
              <button 
                className={`admin-nav-tab ${activeTab === 'products' ? 'active' : ''}`}
                onClick={() => setActiveTab('products')}
              >
                Products
              </button>
              <button 
                className={`admin-nav-tab ${activeTab === 'orders' ? 'active' : ''}`}
                onClick={() => setActiveTab('orders')}
              >
                Orders
              </button>
            </div>
          </div>
        </div>

        <div className="admin-navbar-center">
          <form onSubmit={handleSearch} className="admin-search-form">
            <div className="admin-search-container">
              <Search size={20} className="admin-search-icon" />
              <input
                type="text"
                placeholder="Search vendors, products, orders..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="admin-search-input"
              />
            </div>
          </form>
        </div>

        <div className="admin-navbar-right">
          <div className="admin-navbar-actions">
            <div className="admin-notifications">
              <button 
                className="admin-notification-btn"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <Bell size={20} />
                {unreadCount > 0 && (
                  <span className="admin-notification-badge">{unreadCount}</span>
                )}
              </button>
              
              {showNotifications && (
                <div className="admin-notifications-dropdown">
                  <div className="admin-notifications-header">
                    <h3>Notifications</h3>
                    {notifications.length > 0 && unreadCount > 0 && (
                      <button 
                        className="admin-mark-all-read"
                        onClick={handleMarkAllRead}
                      >
                        Mark all as read
                      </button>
                    )}
                  </div>
                  <div className="admin-notifications-list">
                    {notifications.length > 0 ? (
                      notifications.map((notification) => (
                        <div 
                          key={notification.id} 
                          className={`admin-notification-item ${notification.unread ? 'unread' : ''}`}
                          onClick={() => handleNotificationClick(notification)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="admin-notification-content">
                            <h4>{notification.title}</h4>
                            <p>{notification.message}</p>
                            <span className="admin-notification-time">{notification.time}</span>
                          </div>
                          {notification.unread && <div className="admin-notification-dot"></div>}
                        </div>
                      ))
                    ) : (
                      <div className="no-notifications">
                        <p>No notifications</p>
                        <span>You're all caught up!</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Session Status Component */}
            <div className="admin-session-slot">
              {children}
            </div>

            <div className="admin-user-menu">
              <button 
                className="admin-user-btn"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <div className="admin-user-avatar">
                  <User size={16} />
                </div>
                <span className="admin-user-name">Admin</span>
              </button>
              
              {showUserMenu && (
                <div className="admin-user-dropdown">
                  <div className="admin-user-info">
                    <div className="admin-user-avatar-large">
                      <User size={20} />
                    </div>
                    <div>
                      <h4>Admin User</h4>
                      <p>{userEmail}</p>
                    </div>
                  </div>
                  <div className="admin-user-menu-items">
                    <button className="admin-user-menu-item">
                      <User size={16} />
                      Profile
                    </button>
                    <button className="admin-user-menu-item">
                      <Settings size={16} />
                      Settings
                    </button>
                    <button 
                      className="admin-user-menu-item logout"
                      onClick={logout}
                    >
                      <LogOut size={16} />
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
      <div className="admin-navbar-spacer" aria-hidden="true" />
    </>
  );
};

export default AdminNavbar;
